// extracted by mini-css-extract-plugin
export default {"button":"ArrowButton_button__gUN7Q"};